export default __webpack_public_path__ + "f5f6d6b0f590dd70d65870e25a3aefad.jpg";